import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, NgZone, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { CompanyInfo } from 'src/app/model/company.model';
import { ContactlistInfo } from 'src/app/model/contactlist.model';
import { EmpInfo } from 'src/app/model/emp.model';
import { ProjectRoleInfo } from 'src/app/model/projectrole.model';
import { SupportAuthUser, SupportAuthUserInfo } from 'src/app/model/SupportAuthUserInfo.model';
import { LoaderService } from 'src/app/service/loader.service';
import { TokenService } from 'src/app/service/token.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-authorize-user-project',
  templateUrl: './authorize-user-project.component.html',
  styleUrls: ['./authorize-user-project.component.css']
})
export class AuthorizeUserProjectComponent implements OnInit {

  _ParamProjectCode: string
  _ParamProjectName: string
  baseurl: string;

  displayloading: boolean = false;
  Msgloadding: string = '';
  titlemodal: string;
  detailmodal: string;
  isSubmitted: any;

  itemsSetting: FormArray;
  itemsGetting: FormArray;
  // itemsBaseline: FormArray;
  itemsSetting2: FormArray;
  itemsRole: FormArray;

  ProjectDetailForm: FormGroup;

  addInternalForm!: FormGroup;
  addExternalForm!: FormGroup;
  externalEmp: EmpInfo;

  selectCompanyInternal: CompanyInfo[];
  selectCompanyExternal: CompanyInfo[];
  selectEmpName: EmpInfo[];
  selectProjectRole: ProjectRoleInfo[];
  baselineList: ProjectRoleInfo[];
  selectedCompanyCode: string ;

  supportAuthUserCount: number = 0;
  contactlistArrCount: number = 0;
  supportAuthUserInternalCount = 0;
  // contactlistArrInternal: ContactlistInfo[] ;
  // contactlistArrExtranal: ContactlistInfo[] ;
  contactlistArr: ContactlistInfo[] ;

  supportAuthUserArr: SupportAuthUserInfo[];
  supportAuthUserArrInternal: SupportAuthUserInfo[];
  supportAuthUserArrExternal: SupportAuthUserInfo[];

  isEdit: boolean = false;
  isDelete: boolean = false;
  isEditCfRole: boolean = false;
  // updateRoleFlag: boolean = false;
  employeeselectrun: boolean;
  addInternalEmpStep1: boolean = false;
  addInternalEmpStep2: boolean = false;
  addExtranalEmpStep: boolean = false;
  addExtranalEmpStep2: boolean = false;
  deleteAuthUserList: number[] = new Array<number>();
  // optionContractExUser: string = '';
  formLoaded: boolean = false;

  // for update emp row
  selectCc: string = null;
  selectUserType: string = null;
  selectIndex: number = null;

  selectedTabIndex: number = 0;
  byEmpCode: string = null;

  constructor(private activatedRoute: ActivatedRoute, private httpClient: HttpClient, private formBuilder: FormBuilder,
     private tokenService: TokenService, private loaderService: LoaderService, private zone: NgZone
  ) {
    this.baseurl = environment.base_api;
    this._ParamProjectCode = this.activatedRoute.snapshot.params.ProjectCode;
    this._ParamProjectName = this.activatedRoute.snapshot.params.ProjectName;
   }

  ngOnInit(): void {

    // this.loadContactlist();

    this.loadData();

  }

  loadData(){
    this.deleteAuthUserList = new Array<number>();
    this.byEmpCode = localStorage.getItem("EmpCode");
    this.loadContactCompanyInternal();
    this.loadContactCompanyExternal();
    this.loadProjectRole();

    this.setDefaultProjectDetailForm();

    this.getSupportAuthUserToSetting();

    this.setAddContractForm();
    // this.optionContractExUser = '';

  }

  private setDefaultProjectDetailForm (){

    this.ProjectDetailForm = this.formBuilder.group({
        // BaselineForm: this.formBuilder.group({
        //   items: this.formBuilder.array([this.createItemBaselineDefault()])
        // }),
        // GettingForm: this.formBuilder.group({
        //   items: this.formBuilder.array([this.createItemGettingDefault()])
        // }),
        SettingForm1: this.formBuilder.group({
          items: this.formBuilder.array([this.createItemSettingDefault()])
        }),
        SettingForm2: this.formBuilder.group({
          items: this.formBuilder.array([this.createItemSettingDefault()])
        }),
        RoleForm: this.formBuilder.group({
          items: this.formBuilder.array([this.createItemRoleDefault()])
        })
      });

  }

   importDataFromContractlistBtnClick(){
    $('#ModalConfirmImportContactList').modal('show');

  }

  async confirmImportDataFromContractlistBtnClick(){

    let auth_token = await this.tokenService.RefreshToken();
    $('#ModalConfirmImportContactList').modal('hide');

    if(!!auth_token){
    this.loading(true, 'Saving ...');
    const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
      };
      let objectjson = {}; 
      
      // objectjson['ContactlistProjectCode'] = this._ParamProjectCode;
      // objectjson['ContactlistSupportStatus'] = 'Y';
      objectjson['CreateBy'] = this.byEmpCode;
      objectjson['ProjectCode'] = this._ParamProjectCode;
      // objectjson['ContactlistInfo'] = this.contactlistArr;


      let strJson = JSON.stringify(objectjson);
      console.log("strJson =", strJson);
 
    await this.httpClient.post<any>(this.baseurl + "SupportAuthUser/ImportContractlistToAuthUser", strJson, httpOptions)
            .toPromise().then((data) => {
              console.log("data == ", data);
             this.loading(false, 'Succuessful');
             this.loadData();
    
          }).catch(err => {
            console.error(err);
            this.loading(false, 'fail ..');
          });
    }

  }

  private setAddContractForm(){


    this.addInternalForm = this.formBuilder.group({
      EmpCode: [''],
      EmpName: [''],
      CompanyCode: [''],
      ProjectCode: [''],
      SupportAuthUserRole: [''],
      SupportAuthUserPhone: [''],
      SupportAuthUserEmail: [''],
      SupportAuthUserType: [''],
      EmpNickName: [''],
      SupportAuthUserPosition: ['']
      },
    );

    this.addExternalForm = this.formBuilder.group({
      EmpCode: [''],
      EmpName: [''],
      CompanyCode: [''],
      ProjectCode: [''],
      SupportAuthUserRole: [''],
      SupportAuthUserPhone: [''],
      SupportAuthUserEmail: [''],
      SupportAuthUserType: [''],
      AddUserBy: [''],
      SelectedCompany: [''],
      SupportAuthUserPosition: [''],
      EmpFName: [''],
      EmpLName: [''],
      EmpNickName: [''],
      },
    );

    // this.addExternalForm = this.formBuilder.group({
    //     ProjectCode: [''],
    //     ContactlistProjectName: [''],
    //     ContactlistId: [''],
    //     ContactlistTypeCode: [''],
    //     ContactlistCompanyCode: [''],
    //     ContactlistEmpCode: [''],
    //     ContactlistName: [''],
    //     ContactlistRoleId: [''],
    //     ContactlistTypeName: [''],
    //     ContactlistEmpName: [''],
    //     ContactlistRoleName: [''],
    //     ContactlistNickName: [''],
    //     ContactlistCompanyName: [''],
    //     ContactlistPhone: [''],
    //     ContactlistEmail: [''],
    //     ContactlistReportProjectStatus: [''],
    //     ContactlistReportExecutiveStatus: [''],
    //     ContactlistSupportStatus: [''],
    //     ContactlistPosition: [''],
    //     ContactlistPositionName: [''],
    //   },
    // );

  }
    

    createItemSettingDefault(): FormGroup {
      return this.formBuilder.group({
        EmpCode: [''],
        EmpName: [''],
        CompanyCode: [''],
        ProjectCode: [''],
        SupportAuthUserRole: [''],
        SupportAuthUserPhone: [''],
        SupportAuthUserEmail: [''],
        SupportAuthUserType: [''],
        EmpNickName: [],
        SupportAuthUserPosition: ['']
      },
    );
  }

    createItemSetting(supportAuthUserItem: SupportAuthUserInfo): FormGroup {
      console.log("item === ", supportAuthUserItem);
      let supportAuthRoleId =  Number.parseInt( supportAuthUserItem.SupportAuthUserRole);
      return this.formBuilder.group({
        SupportAuthUserId: [supportAuthUserItem.SupportAuthUserId],
        EmpCode: [supportAuthUserItem.EmpCode],
        EmpName: [supportAuthUserItem.EmpName],
        CompanyCode: [supportAuthUserItem.CompanyCode],
        ProjectCode: [supportAuthUserItem.ProjectCode],
        SupportAuthUserRole: [supportAuthRoleId],
        SupportAuthUserPhone: [supportAuthUserItem.SupportAuthUserPhone],
        SupportAuthUserEmail: [supportAuthUserItem.SupportAuthUserEmail],
        SupportAuthUserType: [supportAuthUserItem.SupportAuthUserType],
        SupportAuthUserPosition: [supportAuthUserItem.SupportAuthUserPosition],
        EmpNickName: [supportAuthUserItem.EmpNickName],

      },
    );
  }
  

  getSupportAuthUserToSetting(){
    console.log("getSupportAuthUserToSetting..");


    this.loadContactlist();
    // .then(data => {
    //         console.log("loadContactlist = ", data.filter(item => 
    //           item.ContactlistSupportStatus === 'Y' && item.FlagDelete === 'N'));
    //         this.contactlistArr = data.filter(item => 
    //           item.ContactlistSupportStatus === 'Y' && item.FlagDelete === 'N');

    //         this.contactlistArrCount = this.contactlistArr.length;  
    //       }
    //     )

    this.getSupportAuthUserlist();
    // .then(data => {
    //   console.log("getSupportAuthUserlist .... ", data);

    //   if(data.length > 0){
    //       this.setSupportAuthUser(data as SupportAuthUserInfo[]);

    //   }else{
    //     this.loading(false, 'success ..');
    //   }

    // }).catch(err => { 
    //   console.error(err);
    //   this.loading(false, 'fail ..');
    // })


  }

  setSupportAuthUser(data: SupportAuthUserInfo[]){

      this.supportAuthUserCount = data.length;
      this.supportAuthUserArr = data;

      this.supportAuthUserArrInternal = data.filter(item => item.SupportAuthUserType === '1');
      this.supportAuthUserArrExternal = data.filter(item => item.SupportAuthUserType === '2');

      console.log("this.supportAuthUserArr === ", this.supportAuthUserArr);

      if(this.supportAuthUserArrInternal.length > 0){
          let countInternal = 0;
          this.supportAuthUserArrInternal.forEach((traget, indextraget) => {
          console.log("traget === ", traget);

          this.itemsSetting.push(this.createItemSetting(traget));
    
          if(traget.SupportAuthUserRole != null && traget.SupportAuthUserRole != '' &&
           traget.SupportAuthUserRole != '0' && traget.SupportAuthUserType == '1'){
              countInternal++;
          }

        });
        this.supportAuthUserInternalCount = countInternal;
      }



      if(this.supportAuthUserArrExternal.length > 0){
        setTimeout(() => {
            this.supportAuthUserArrExternal.forEach((traget, indextraget) => {
              this.itemsSetting2.push(this.createItemSetting(traget));
            });

        }, 200);

      }

        this.loading(false, 'success ..');


  }


    createItemRoleDefault(): FormGroup {
      return this.formBuilder.group({
        ProjectCode: [''],
        ProjectRoleName: ['', Validators.required],
        ProjectRoleTier: ['', Validators.required],
      },
      );
    }

    createItemRole(baselineitem: ProjectRoleInfo): FormGroup {
      return this.formBuilder.group({
        ProjectCode: [''],
        ProjectRoleId: [baselineitem.ProjectRoleId || ''],
        ProjectRoleName: [baselineitem.ProjectRoleName || '', Validators.required],
        ProjectRoleTier: [baselineitem.ProjectRoleTier || '', Validators.required]
      },
      );
    }


    addItem(): void {
      this.itemsRole = this.ProjectDetailForm.get('RoleForm').get('items') as FormArray;
      this.itemsRole.push(this.createItemRoleDefault());
    }

    addContactInternalItem(): void {
      // this.itemsSetting = this.ProjectDetailForm.get('SettingForm1').get('items') as FormArray;
      // this.itemsSetting.push(this.createItemSettingDefault());

      this.setAddContractForm();
      // Modal add contract  
       $('#ModalAddContractInternal').modal('show'); 
        // this.isEdit = true;  
      //  this.selectInternalEmpStep = true;
      this.addInternalEmpStep1 = true;
      this.addInternalEmpStep2 = false;
    }

    addContactExtranalItem(): void {
      // this.itemsSetting = this.ProjectDetailForm.get('SettingForm2').get('items') as FormArray;
      // this.itemsSetting.push(this.createItemSettingDefault());
      
      // this.optionContractExUser = '';
      this.setAddContractForm();
       $('#ModalAddContractExternal').modal('show'); 
       
    }

    onDropdownChange(event: Event): void {
      const value = (event.target as HTMLSelectElement).value;
      if (value) {
        this.isEdit = true;
      }
    }

    onInputChange(event: Event): void {
      const value = (event.target as HTMLInputElement).value;
      this.isEdit = !!value;
    }

    onInputChangecfRole(event: Event): void {
      const value = (event.target as HTMLInputElement).value;
      if (value) {
        this.isEditCfRole = true;
      }
    }


  empselect(i, companycode: string, userType: string){
      console.log("empselect()...", i, companycode, userType);
        // if (!this.isEdit) {
        //   return;
        // }

        this.selectCc = companycode;
        this.selectIndex = i;

        if(userType == '1'){
          this.selectUserType = "Internal";
        }else if(userType == '2'){
          this.selectUserType = "External";
        }

        this.employeeselectrun = true;
        // this.employeeselectreturnto = i;
        // this.selectedemp = null;
        $('#ModalEmpSelect').modal('show'); 
        this.isEdit = true; 

  }

  selectedEmp(event) {
    console.log("selectedEmp.x...", event, this.selectUserType)

    let emp: EmpInfo = event[0] ;
    // Check current row
    if(this.selectUserType == 'Internal'){
      this.itemsSetting = this.ProjectDetailForm.get('SettingForm1').get('items') as FormArray;

      let authUserInfo: SupportAuthUserInfo = this.itemsSetting.controls[this.selectIndex].value;
      console.log("authUserInfo == ", authUserInfo);

      if(authUserInfo.EmpCode != emp.EmpCode){
          
        this.itemsSetting.at(this.selectIndex).patchValue({
            CompanyCode: emp.CompanyCode,
            EmpCode: emp.EmpCode,
            EmpName: emp.EmpName_EN,
            SupportAuthUserEmail: emp.Mail,
            SupportAuthUserPhone: emp.Mobile,
            EmpNickName: emp.NickName,        

        });

      }

    }else if(this.selectUserType == 'External'){
      this.itemsSetting = this.ProjectDetailForm.get('SettingForm2').get('items') as FormArray;
      let authUserExInfo: SupportAuthUserInfo = this.itemsSetting.controls[this.selectIndex].value;
      
      if(authUserExInfo.EmpCode != emp.EmpCode){
          
        this.itemsSetting.at(this.selectIndex).patchValue({
            CompanyCode: emp.CompanyCode,
            EmpCode: emp.EmpCode,
            EmpName: emp.EmpName_EN,
            SupportAuthUserEmail: emp.Mail,
            SupportAuthUserPhone: emp.Mobile,
            EmpNickName: emp.NickName,        
        });

      }


    }


    $('#ModalEmpSelect').modal('hide'); 
    this.selectCc = null;
    this.selectUserType = null;
    this.selectIndex = null;

  }

  selectedAddEmpUser(event){
    console.log("selectedEmp User....", event)

    // Check Dupplicate EmpCode
    let dup: boolean = false;

    if(event[0].EmpType == "1"){

      dup = this.supportAuthUserArrInternal.some(x => x.EmpCode === event[0].EmpCode);

      if(dup){
        alert("Duplicate Internal user " + event[0].EmpCode);
        this.addInternalEmpStep1 = false;
        this.addInternalEmpStep2 = false;
        $('#ModalAddContractInternal').modal('hide'); 

    }else{
        this.addInternalForm = this.formBuilder.group({
        EmpCode: [event[0].EmpCode],
        EmpName: [event[0].EmpName_TH],
        SupportAuthUserEmail: [event[0].Mail],
        SupportAuthUserPhone: [event[0].Mobile],
        CompanyCode: [this.selectedCompanyCode],
        SupportAuthUserRole: [''],
        SupportAuthUserType: [1],
        SupportAuthUserPosition : ['']

      });
      this.addInternalEmpStep1 = true;
      this.addInternalEmpStep2 = false;
    }

    }else if(event[0].EmpType == "2"){
        this.externalEmp = null;
        dup = this.supportAuthUserArrExternal.some(x => x.EmpCode === event[0].EmpCode);
        console.log("bbbbbbbbbb.....");
          this.addExtranalEmpStep2 = false;
        if(dup){
            alert("Duplicate External user " + event[0].EmpCode);
            // this.addInternalEmpStep1 = false;
            this.addExtranalEmpStep2 = false;
            $('#ModalAddContractExternal').modal('hide'); 

        }else{
          this.addExtranalEmpStep2 = false;
          this.setExternalEmpForm(event[0]);
          // this.addExtranalEmpStep1 = true;
        }

    }

  }

  setExternalEmpForm(emp: EmpInfo){
    this.externalEmp = emp ;
    console.log("externalEmp == ", this.externalEmp);
      this.addExternalForm.get('EmpCode').setValue(this.externalEmp.EmpCode);
      this.addExternalForm.get('EmpName').setValue(this.externalEmp.EmpName_TH);
      this.addExternalForm.get('SupportAuthUserEmail').setValue(this.externalEmp.Mail);
      this.addExternalForm.get('SupportAuthUserPhone').setValue(this.externalEmp.Mobile);
      // this.addExternalForm.get('CompanyCode').setValue(this.selectedCompanyCode);
      this.addExternalForm.get('SupportAuthUserType').setValue(2);
      this.addExternalForm.get('EmpNickName').setValue(this.externalEmp.NickName);

      console.log("bbbbbbbbbb111.....",  this.addExternalForm);  

  }

  selectedAddEmpUserExternal(event){
    console.log("selectedEmp Ex....", event)

    // Check Dupplicate EmpCode
    let dup: boolean = false;

    // for(let i=0; i< this.supportAuthUserArrExternal.length; i++){
    //   if(this.supportAuthUserArrExternal[i].EmpCode === event[0].EmpCode){
    //     dup = true;
    //     break;
    //   }
    // }

    // if(dup){
    //     alert("Duplicate user " + event[0].EmpCode);
    //     // this.addInternalEmpStep1 = false;
    //     this.addExtranalEmpStep2 = false;
    //     $('#ModalAddContractExternal').modal('hide'); 

    // }else{
    //     this.addExternalForm = this.formBuilder.group({
    //       EmpCode: [event[0].EmpCode],
    //       EmpName: [event[0].EmpName_TH],
    //       CompanyCode: [this.selectedCompanyCode],
    //       // ProjectCode: [''],
    //       SupportAuthUserRole: [''],
    //       SupportAuthUserPhone: [event[0].Mobile],
    //       SupportAuthUserEmail: [event[0].Mail],
    //       SupportAuthUserType: [2],
    //       SupportAuthUserPosition : ['']

    //   });
    //   // this.addExtranalEmpStep1 = true;
    //   this.addExtranalEmpStep2 = false;
    // }

  }

    editConfigRolesBtnClick(){
      $('#ModalConfigRole').modal('show');  
    }

    addNewConfigItemRoleBtnClick(){
      this.isEditCfRole = true;
      this.itemsRole = this.ProjectDetailForm.get('RoleForm').get('items') as FormArray;
      this.itemsRole.push(this.createItemRoleDefault());
    }

    loading(flag: boolean, Msg: string = '') {
      this.displayloading = flag;
      this.Msgloadding = Msg;
    }

    async onSubmitConfigRole(){


    if (this.ProjectDetailForm.get('RoleForm').valid) {
      var auth_token = await this.tokenService.RefreshToken();
      if (!!auth_token) {
          this.loading(true, 'Saving ...');

          if (true) {
            console.log('form submitted');
            const httpOptions = {
              headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${auth_token}`
              })
            };
            var listsetup = this.ProjectDetailForm.get('RoleForm').get('items') as FormArray;
            var listsetupcontrols = listsetup.controls;
            var arrayinsert = [];
            listsetupcontrols.forEach((itemcurrent) => {
              var objectjson = {}; 
              objectjson['ProjectRoleId'] = itemcurrent.value.ProjectRoleId;
              objectjson['ProjectRoleProjectCode'] = this._ParamProjectCode;
              objectjson['ProjectRoleName'] = itemcurrent.value.ProjectRoleName;
              objectjson['ProjectRoleTier'] = itemcurrent.value.ProjectRoleTier;
              objectjson['ProjectRoleCreateBy'] = localStorage.getItem("EmpCode");
              arrayinsert.push(objectjson);
            });

            let strjson = JSON.stringify(arrayinsert);

            this.isSubmitted = this.httpClient.post<any>(this.baseurl + "ProjectRole/InsertProjectRole", strjson, httpOptions)
              .subscribe(result => this.isSubmitted = result, failCb => {
                $('#ModalConfigRole').modal('hide');
                console.log("Insert fail")
                this.loading(false);
                this.titlemodal = 'Saving Project Role fail.';
                this.detailmodal = 'Your project role was saved fail.';
                $('#ModalAuthStatus').modal('show');
              },
                () => {
                  console.log("Insert = " + this.isSubmitted)
                  $('#ModalConfigRole').modal('hide');
                  this.loading(false);
                  this.titlemodal = 'Saving Project Role done.';
                  this.detailmodal = 'Your project role was updated successfully.';
                  $('#ModalAuthStatus').modal('show');
                }
              )
          }
        } else {
        // this.markFormGroupTouched(this.ProjectDetailForm.get('RoleForm') as FormGroup);
      }
    }

      this.isEditCfRole = false;
      
    }

    // User type = 1
    async onUpdateAuthUserInternal(){
      let updateData = this.ProjectDetailForm.get('SettingForm1').get('items') as FormArray;
      let supportAuthUserList: SupportAuthUserInfo[] = updateData.value as SupportAuthUserInfo[];
      console.log("onUpdateAuthUserInternal..." , supportAuthUserList);

      var auth_token = await this.tokenService.RefreshToken();
        if (!!auth_token) {
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth_token}`
            })
          };


          return await this.httpClient.put<any>(this.baseurl + "SupportAuthUser/UpdateSupportAuthUser",
             supportAuthUserList, httpOptions)
              .toPromise()
              .then(data => {
                if(data){
                  this.isEdit = false;
                  this.loadData();
                  // this.loading(false, 'Successful');
                }
              }).catch(err => {
                // this.loading(false, 'fail');
              });        

        }

    }

    // User type = 2
    async onUpdateAuthUserExternal(){
      let updateData = this.ProjectDetailForm.get('SettingForm2').get('items') as FormArray;
      let supportAuthUserList: SupportAuthUserInfo[] = updateData.value as SupportAuthUserInfo[];
      console.log("onUpdateAuthUserExternal..." , supportAuthUserList);

      var auth_token = await this.tokenService.RefreshToken();
        if (!!auth_token) {
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth_token}`
            })
          };


        return await this.httpClient.put<any>(this.baseurl + "SupportAuthUser/UpdateSupportAuthUser",
             supportAuthUserList, httpOptions)
              .toPromise()
              .then(data => {
                if(data){
                  this.isEdit = false;
                  this.loadData();
                  // this.loading(false, 'Successful');
                  // window.location.reload();
                }
              }).catch(err => {
                // this.loading(false, 'fail');
              });        

        }

    }

    // User type = 1
    async onSaveAddContractInternal(){
      console.log("onSaveAddContractInternal..." , this.addInternalForm);
      if(this.addInternalForm.get('CompanyCode').value === ''){
        alert("Please select CompanyCode");
        return;
      }

      if(this.addInternalForm.get('EmpCode').value === ''){
        console.log('xxxxxx1');
        alert("Please select employee");
        return;
      }

      if(this.addInternalForm.get('SupportAuthUserRole').value === ''){
        alert("Please select Role");
        return;
      }

      // Send create API
      let supportAuthUserInfo = new SupportAuthUserInfo();
      // let userType = this.addInternalForm.get('SupportAuthUserType').value;
    
      supportAuthUserInfo.EmpCode = this.addInternalForm.get('EmpCode').value;
      supportAuthUserInfo.CompanyCode = this.addInternalForm.get('CompanyCode').value;
      supportAuthUserInfo.SupportAuthUserType = this.addInternalForm.get('SupportAuthUserType').value;
      supportAuthUserInfo.ProjectCode = this._ParamProjectCode;
      supportAuthUserInfo.SupportAuthUserEmail = this.addInternalForm.get('SupportAuthUserEmail').value;
      supportAuthUserInfo.SupportAuthUserPosition = this.addInternalForm.get('SupportAuthUserPosition').value;
      supportAuthUserInfo.SupportAuthUserRole = this.addInternalForm.get('SupportAuthUserRole').value;

      supportAuthUserInfo.CreateBy = this.byEmpCode;

      console.log("supportAuthUserInfo for Insert internal == ", supportAuthUserInfo);
      

      // Close modal
      $('#ModalAddContractInternal').modal('hide'); 
      this.addInternalEmpStep1 = false;
      this.addInternalEmpStep2 = false;

      var auth_token = await this.tokenService.RefreshToken();
        if (!!auth_token) {
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth_token}`
            })
          };

      let strjson = JSON.stringify(supportAuthUserInfo);

      // await this.httpClient.post<boolean>(this.baseurl + "SupportAuthUser/CreateSupportAuthUser", strjson, httpOptions)
      //     .toPromise()
      //     .then(data => {
      //        this.loading(false);
      //       if(data){
      //         this.loadData();
      //       }
      //     }).catch(
            
      //     );

      this.loading(false);

      
      return this.httpClient
        .post<any>(this.baseurl + "SupportAuthUser/CreateSupportAuthUser", strjson, httpOptions)
          .pipe(
            finalize(() => this.loaderService.setLoading(false))
          )
        .subscribe({
          next: (data) => {
            if (data) {
              this.loadData();
            }
          },
          error: (err) => {
            console.error("API Error:", err);
            // alert("Cannot save data. Please try again.");
          }
        });

      }

    }

    // User type = 2
    async onSaveAddContractExternal(){
      console.log("save external === ", this.addExternalForm);

      if(this.addExternalForm.get('CompanyCode').value === ''){
        alert("Please select CompanyCode");
        return;
      }
      if(this.addExternalForm.get('AddUserBy').value === ''){
        alert("Please select your option");
        return;
      }
      if(this.addExternalForm.get('SupportAuthUserEmail').value === ''){
        alert("Please input Email");
        return;
      }
      // if(this.addExternalForm.get('EmpName').value === ''){
      //   if(this.addExternalForm.get('EmpFName').value !== '' && 
      //   this.addExternalForm.get('EmpLName').value !== ''){

      //   }else{
      //     alert("Please input customer name");
      //     return;
      //   }
      // }

      
       // Send create API
      let supportAuthUserInfo = new SupportAuthUserInfo();

      if(this.addExternalForm.get('AddUserBy').value == '1'){
          if(this.addExternalForm.get('EmpCode').value) 
            supportAuthUserInfo.EmpCode = this.addExternalForm.get('EmpCode').value;
          if(this.addExternalForm.get('EmpFName').value !== '' && 
            this.addExternalForm.get('EmpLName').value !== ''){
             supportAuthUserInfo.EmpName = this.addExternalForm.get('EmpFName').value + " " +
              this.addExternalForm.get('EmpLName').value;
        }
        supportAuthUserInfo.EmpNickName = this.addExternalForm.get('EmpNickName').value;

      }else if(this.addExternalForm.get('AddUserBy').value == '2'){
        supportAuthUserInfo.EmpCode = null;
        supportAuthUserInfo.EmpName = this.addExternalForm.get('EmpName').value;
        supportAuthUserInfo.EmpNickName = this.addExternalForm.get('EmpNickName').value;
      }

      supportAuthUserInfo.CompanyCode = this.addExternalForm.get('CompanyCode').value;
      supportAuthUserInfo.SupportAuthUserType = "2";
      supportAuthUserInfo.ProjectCode = this._ParamProjectCode;
      supportAuthUserInfo.SupportAuthUserEmail = this.addExternalForm.get('SupportAuthUserEmail').value;

      if(this.addExternalForm.get('SupportAuthUserPosition').value){
        supportAuthUserInfo.SupportAuthUserPosition = this.addExternalForm.get('SupportAuthUserPosition').value;
      }else{
        supportAuthUserInfo.SupportAuthUserPosition = "Customer";
      }
      // supportAuthUserInfo.SupportAuthUserRole = this.addExternalForm.get('SupportAuthUserRole').value;
      supportAuthUserInfo.SupportAuthUserRole = "0";

      supportAuthUserInfo.CreateBy = this.byEmpCode;

      console.log("supportAuthUserInfo for Insert external == ", supportAuthUserInfo);

      $('#ModalAddContractExternal').modal('hide'); 
      this.addExtranalEmpStep = false;
      this.addExtranalEmpStep2 = false;
      var auth_token = await this.tokenService.RefreshToken();
        if (!!auth_token) {
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth_token}`
            })
          };

      let strjson = JSON.stringify(supportAuthUserInfo);

      return this.httpClient.post<boolean>(this.baseurl + "SupportAuthUser/CreateSupportAuthUser", strjson, httpOptions)
      //     .toPromise() 
      //     .then(data => {
      //       console.log("dddd = ", data);
      //        this.loading(false);
      //       if(data){
      //         this.loadData();
      //       }
      //     }).catch();
          .pipe(
                finalize(() => this.loaderService.setLoading(false))
              )
        .subscribe({
          next: (data) => {
            if (data) {
              this.loadData();
            }
          },
          error: (err) => {
            console.error("API Error:", err);
            // alert("Cannot save data. Please try again.");
          }
        });
      
      }

    }

    onselectEmpInternalInput(){
      this.addInternalEmpStep1 = false;
      this.addInternalEmpStep2 = true;
    }

    removeContractItemInternal(index: number){
      this.isDelete = true; 
      this.itemsSetting = this.ProjectDetailForm.get('SettingForm1').get('items') as FormArray;
      // console.log("this.itemsSetting = ", this.itemsSetting.controls[index].value.SupportAuthUserId)
      this.deleteAuthUserList.push(this.itemsSetting.controls[index].value.SupportAuthUserId);
      this.itemsSetting.removeAt(index);

    }

    removeContractItemExtranal(index: number){
      this.isDelete = true; 
      this.itemsSetting = this.ProjectDetailForm.get('SettingForm2').get('items') as FormArray;
      this.deleteAuthUserList.push(this.itemsSetting.controls[index].value.SupportAuthUserId);
      this.itemsSetting.removeAt(index);

    }

    removeRoleItem(index: number){
      this.isEditCfRole = true;
      // this.
      this.itemsRole = this.ProjectDetailForm.get('RoleForm').get('items') as FormArray;
      this.itemsRole.removeAt(index);

    }


    onCancelAuth(){
      window.location.reload();
    }

    onCompanyChangeInternal(): void {
        this.selectedCompanyCode = this.addInternalForm.get('CompanyCode').value;
        this.addInternalForm.get('EmpCode').setValue('');
        this.addInternalForm.get('EmpName').setValue('');
        this.addInternalForm.get('SupportAuthUserEmail').setValue('');


    }
    onCompanyChangeExternal(): void {
        this.selectedCompanyCode = this.addExternalForm.get('CompanyCode').value;
        this.addExternalForm.get('AddUserBy')?.setValue('');

        this.addExternalForm.get('EmpCode').setValue('');
        this.addExternalForm.get('EmpName').setValue('');
        this.addExternalForm.get('SupportAuthUserEmail').setValue('');
    }

    onSelectedOptionCreateContractExternal(event: Event): void {
      this.addExtranalEmpStep2 = true;
      // this.addExternalForm.get('AddUserBy').setValue('');
      const value = (event.target as HTMLSelectElement).value;
      if (value) {
       this.addExternalForm.get('AddUserBy').setValue(value);
      }
    }

     async onDeleteAuthUser(){

      var auth_token = await this.tokenService.RefreshToken();
        if (!!auth_token) {
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth_token}`
            })
          };

          if(this.deleteAuthUserList.length > 0){

           this.httpClient.put<boolean>(this.baseurl + "SupportAuthUser/DeleteSupportAuthUser",
             this.deleteAuthUserList, httpOptions)
            .toPromise().then((data) => {
              this.isDelete = false;
             if(data){
              this.loadData();
             }
    
            });
          }else{
            this.isDelete = false;
          }


        }

    }


    async loadContactCompanyInternal() {
        var auth_token = await this.tokenService.RefreshToken();
        if (!!auth_token) {
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth_token}`
            })
          };
    
          var objectjson = {};
          objectjson['CompanyCode'] = this._ParamProjectCode;
    
          let strjson = JSON.stringify(objectjson);
    
          await this.httpClient.post<CompanyInfo[]>(this.baseurl + "Company/GetContactCompanyInternal", strjson, httpOptions)
            .toPromise().then((data) => {
              this.selectCompanyInternal = data;
    
            });
        }
      }
    
      async loadContactCompanyExternal() {
        var auth_token = await this.tokenService.RefreshToken();
        if (!!auth_token) {
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth_token}`
            })
          };
    
          var objectjson = {};
          objectjson['CompanyCode'] = this._ParamProjectCode;
    
          let strjson = JSON.stringify(objectjson);
    
          await this.httpClient.post<CompanyInfo[]>(this.baseurl + "Company/GetContactCompanyExternal", strjson, httpOptions)
            .toPromise().then((data) => {
              this.selectCompanyExternal = data;
    
            });
        }
      }


    async getSupportAuthUserlist(){
        var auth_token = await this.tokenService.RefreshToken();
        this.formLoaded = false;
      if (!!auth_token) {
        let params = new HttpParams();

        params = params.set("projectCode", this._ParamProjectCode);
        // params.set("", );

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          }),
          params: params
        };

      
      let url = this.baseurl + "SupportAuthUser/GetSupportAuthUserlist";


      return this.httpClient.get<SupportAuthUserInfo[]>(
        url , httpOptions ) 
        .pipe(
            finalize(() => this.loaderService.setLoading(false))
          )
        .subscribe({
          next: (data) => {
              this.itemsSetting = this.ProjectDetailForm.get('SettingForm1').get('items') as FormArray;
              this.itemsSetting.clear();
              this.itemsSetting2 = this.ProjectDetailForm.get('SettingForm2').get('items') as FormArray;  
              this.itemsSetting2.clear();  
            // let dataInfo = data as SupportAuthUserInfo[];
            this.zone.run(() => {
                if (data.length > 0) {
                    this.setSupportAuthUser(data);
                    this.formLoaded = true;
                    this.selectedTabIndex = 0;
                }
             });
          },
          error: (err) => {
            console.error("API Error:", err);
            // alert("Cannot save data. Please try again.");
          }
        });



      }


    }  
    

    async loadContactlist() {
      var auth_token = await this.tokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
  
        var objectjson = {};
        objectjson['ContactlistProjectCode'] = this._ParamProjectCode;
        objectjson['ContactlistSupportStatus'] = 'Y';
        let strjson = JSON.stringify(objectjson);
  
        return this.httpClient.post<ContactlistInfo[]>(
          this.baseurl + "Contactlist/GetContactlist", strjson, httpOptions)
          // .toPromise()
          .pipe(
            finalize(() => this.loaderService.setLoading(false))
          )
          .subscribe({
            next: (data) => {
              // if (data) {
                  // console.log("loadContactlist = ", data.filter(item => 
                  //   item.ContactlistSupportStatus === 'Y' && item.FlagDelete === 'N'));
                  this.contactlistArr = data.filter(item => 
                    item.ContactlistSupportStatus === 'Y' && item.FlagDelete === 'N');

                  this.contactlistArrCount = this.contactlistArr.length;  
              // }
            },
            error: (err) => {
              console.error("API Error:", err);
              // alert("Cannot save data. Please try again.");
            }
          });
      }
    }
  

    async loadProjectRole() {
      var auth_token = await this.tokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['ProjectRoleProjectCode'] = this._ParamProjectCode;

        let strjson = JSON.stringify(objectjson);

        this.httpClient.post<ProjectRoleInfo[]>(this.baseurl + "ProjectRole/GetProjectRole", strjson, httpOptions)
          // .toPromise().then((data) => {
          //   this.selectProjectRole = data;
          //   this.baselineList = data;
          //   console.log("baselineList == ", this.baselineList);
          //   this.GetBaselineToSetup(data);
          // });

          .pipe(finalize(() => this.loaderService.setLoading(false)))
          .subscribe({
            next: (data) => {

              this.selectProjectRole = data;
              this.baselineList = data;
              console.log("baselineList == ", this.baselineList);
              this.GetBaselineToSetup(data);

            },
            error: (err) => {
              console.error("API Error:", err);
              // alert("Cannot save data. Please try again.");
            }
          });
      }
    }

  GetBaselineToSetup(data) {
    // this.loadBaseline().then((data) => {
      this.baselineList = data;
      this.itemsRole = this.ProjectDetailForm.get('RoleForm').get('items') as FormArray;
      this.itemsRole.clear();
      this.baselineList.forEach((traget, indextraget) => {
        this.itemsRole.push(this.createItemRole(traget));
      });
    // });
  }

  //   async loadBaseline() {

  //   var auth_token = await this.tokenService.RefreshToken();
  //   if (!!auth_token) {
  //     const httpOptions = {
  //       headers: new HttpHeaders({
  //         'Content-Type': 'application/json',
  //         'Authorization': `Bearer ${auth_token}`
  //       })
  //     };

  //     var objectjson = {};
  //     objectjson['ProjectRoleProjectCode'] = this._ParamProjectCode;

  //     let strjson = JSON.stringify(objectjson);

  //     return await this.httpClient.post<ProjectRoleInfo[]>(this.baseurl + "ProjectRole/GetProjectRole", strjson, httpOptions)
  //       .toPromise()
  //   }
  // }


  formatPhone(phoneNumber: string): string {
      if (!phoneNumber) return '';

      const digits = phoneNumber.replace(/\D/g, '');

      return digits.replace(/(\d{3})(\d{3})(\d+)/, '$1-$2-$3');
    }

}
